export default __webpack_public_path__ + "static/media/git.47e0fe4e.png";